if (!customElements.get('desktop-menu-drawer')) {
  class DesktopMenuDrawer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.tabs = this.querySelectorAll('.drawer-tab');
      this.panels = this.querySelectorAll('.drawer-panel');

      this.onKeyDown = this.handleKeyDown.bind(this);
      this.onOverlayClick = this.handleOverlayClick.bind(this);
      this.onMediaChange = this.handleMediaChange.bind(this);
      this.onHeaderClick = this.handleHeaderClick.bind(this);

      this.bindTabs();
      this.bindSubTabs();
      this.bindHeaderNav();
    }

    bindTabs() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          if (tab.dataset.leaf === 'true') return;
          e.preventDefault();
          this.activateTab(tab);
        });
      });
    }

    bindSubTabs() {
      var self = this;
      this.querySelectorAll('.drawer-subtab').forEach(function(subtab) {
        subtab.addEventListener('mouseenter', function() { self.activateSubTab(subtab); });
        subtab.addEventListener('focus', function() { self.activateSubTab(subtab); });
      });
      this.querySelectorAll('.drawer-hub a[data-visual], .drawer-sub-panel a[data-visual]').forEach(function(link) {
        link.addEventListener('mouseenter', function() {
          var panel = link.closest('.drawer-panel');
          if (panel) self.updateVisual(panel, link);
        });
      });
    }

    showHub(panel) {
      if (!panel) return;
      panel.querySelectorAll('.drawer-subtab').forEach(s => s.classList.remove('active'));
      panel.querySelectorAll('.drawer-sub-panel').forEach(p => p.classList.remove('active'));
      var hub = panel.querySelector('[data-hub]');
      if (hub) {
        hub.classList.add('active');
        this.updateVisual(panel, hub || panel.querySelector('.drawer-subtab[data-visual]'));
        return;
      }
      var firstExpander = panel.querySelector('.drawer-subtab[data-subhandle]');
      if (firstExpander) {
        this.activateSubTab(firstExpander);
        return;
      }
      this.updateVisual(panel, panel.querySelector('.drawer-subtab[data-visual]'));
    }

    activateSubTab(subtab) {
      var panel = subtab.closest('.drawer-panel');
      if (!panel) return;
      var handle = subtab.dataset.subhandle;
      panel.querySelectorAll('.drawer-subtab').forEach(s => {
        s.classList.toggle('active', s === subtab);
      });
      var hub = panel.querySelector('[data-hub]');
      var activeSub = null;
      if (handle) {
        if (hub) hub.classList.remove('active');
        panel.querySelectorAll('.drawer-sub-panel').forEach(p => {
          var on = p.dataset.subpanel === handle;
          p.classList.toggle('active', on);
          if (on) activeSub = p;
        });
      } else {
        panel.querySelectorAll('.drawer-sub-panel').forEach(p => p.classList.remove('active'));
        if (hub) hub.classList.remove('active');
      }
      this.updateVisual(panel, activeSub || subtab);
    }

    updateVisual(panel, source) {
      var slot = panel.querySelector('[data-visual-slot]');
      if (!slot) return;
      var img = slot.querySelector('img');
      var src = source && source.dataset.visual;
      if (!src || !img) {
        slot.hidden = true;
        if (img) {
          img.removeAttribute('src');
          img.alt = '';
        }
        return;
      }
      img.src = src;
      img.alt = source.dataset.visualAlt || '';
      slot.hidden = false;
    }

    bindHeaderNav() {
      var self = this;
      var navLinks = document.querySelectorAll('.header-main-menu .item .nav-1');
      navLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
          if (!$s.media.isLarge) return;
          var item = link.closest('.item');
          if (!item || !item.classList.contains('has-dropdown')) return;
          e.preventDefault();
          var parent = link.closest('[data-parent]');
          var handle = parent ? parent.dataset.parent : null;
          if (self.isOpen() && self._activeHandle === handle) {
            self.close();
          } else {
            self.open(handle);
          }
        });
      });
    }

    activateTab(tab) {
      var handle = tab.dataset.handle;
      this.tabs.forEach(t => {
        t.classList.toggle('active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      this.panels.forEach(p => {
        p.classList.toggle('active', p.id === 'drawer-panel-' + handle);
      });
      this._activeHandle = handle;

      var activePanel = this.querySelector('#drawer-panel-' + handle);
      if (activePanel) this.showHub(activePanel);
    }

    open(handle) {
      var searchDrawer = document.getElementById('desktop-search-drawer');
      if (searchDrawer && searchDrawer.classList.contains('open') && typeof searchDrawer.close === 'function') {
        searchDrawer.close();
      }
      if (handle) {
        var tab = this.querySelector('.drawer-tab[data-handle="' + handle + '"]');
        if (tab) this.activateTab(tab);
      }
      this._activeHandle = handle;
      this.syncDrawerPosition();
      this.classList.add('open');
      this.removeAttribute('aria-hidden');
      document.documentElement.classList.add('desktop-menu-drawer-open');
      $s.showOverlay();
      document.addEventListener('keydown', this.onKeyDown);
      document.querySelector('#overlay').addEventListener('click', this.onOverlayClick);
      window.addEventListener('mediaChange', this.onMediaChange);
      var headerContent = document.querySelector('#header .container.header-content');
      if (headerContent) headerContent.addEventListener('click', this.onHeaderClick);
      setTimeout(() => $s.trapFocus(this), 100);
    }

    syncDrawerPosition() {
      var headerContent = document.querySelector('#header .container.header-content');
      if (headerContent) {
        var rect = headerContent.getBoundingClientRect();
        this.style.setProperty('--drawer-top-offset', rect.top + 'px');
        this.style.setProperty('--drawer-topbar-height', rect.height + 'px');
      }
    }

    close() {
      this.classList.remove('open');
      document.documentElement.classList.remove('desktop-menu-drawer-open');
      this.setAttribute('aria-hidden', 'true');
      this._activeHandle = null;
      $s.removeTrapFocus();
      $s.hideOverlay();
      document.removeEventListener('keydown', this.onKeyDown);
      var overlay = document.querySelector('#overlay');
      if (overlay) overlay.removeEventListener('click', this.onOverlayClick);
      window.removeEventListener('mediaChange', this.onMediaChange);
      var headerContent = document.querySelector('#header .container.header-content');
      if (headerContent) headerContent.removeEventListener('click', this.onHeaderClick);
    }

    isOpen() {
      return this.classList.contains('open');
    }

    handleKeyDown(e) {
      if (e.key === 'Escape' && this.isOpen()) {
        e.preventDefault();
        this.close();
      }
    }

    handleOverlayClick() {
      if (this.isOpen()) this.close();
    }

    handleHeaderClick(e) {
      if (!this.isOpen()) return;
      if (e.target.closest('.header-main-menu .nav-1')) return;
      this.close();
    }

    handleMediaChange() {
      if (!$s.media.isLarge && this.isOpen()) {
        this.close();
      }
    }
  }

  customElements.define('desktop-menu-drawer', DesktopMenuDrawer);
}
